import store from '@/store'
import DefaultLayout from '../../components/DefaultLayout.vue'
import { permissions } from '@mocks/permissions'
import { ROUTES } from '@router/modules/constants'
const NotFound404 = () => import(/* webpackChunkName: "not-found" */ '@pages/NotFound404.vue')
const SignIn = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/SignInPage.vue')
const ConfirmEmail = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/ConfirmEmail.vue')
const CompleteSignUp = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/CompleteSignUp.vue')
const AddAgency = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/AddAgency.vue')
const AddAgencyAtlassian = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/AddAgencyAtlassian.vue')
const InviteTeammates = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/InviteTeammates.vue')
const InviteTeammatesAtlassian = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/InviteTeammatesAtlassian.vue')
const ConfirmationLinkExpired = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/ConfirmationLinkExpired.vue')
const InvitationLinkExpired = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/InvitationLinkExpired.vue')
const Welcome = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/Welcome.vue')
const SignUp = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/SignUp.vue')
const PasswordReset = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/PasswordReset.vue')
const PasswordUpdate = () => import(/* webpackChunkName: "auth" */ '@pages/sign-in-up/PasswordUpdate.vue')
const Home = () => import(/* webpackChunkName: "home" */ '../../components/Home')
const Users = () => import(/* webpackChunkName: "users" */ '../../components/UsersInfo/Users')
const Projects = () => import(/* webpackChunkName: "projects" */ '../../components/Projects')
const LogTimeReport = () => import(/* webpackChunkName: "reports" */ '../../components/LogTimeReport')
const BacklogTimeReport = () => import(/* webpackChunkName: "reports" */ '../../components/BacklogTimeReport')
const KpiReport = () => import(/* webpackChunkName: "reports" */ '../../components/KpiReport')
// const UnitManagement = () => import('../../components/UnitManagement')
const Profile = () => import(/* webpackChunkName: "profile" */ '../../components/Profile')
const ProfileEdit = () => import(/* webpackChunkName: "profile" */ '../../components/ProfileEdit')
const MyProfile = () => import(/* webpackChunkName: "profile" */ '../../components/MyProfile')
const MyProfileEdit = () => import(/* webpackChunkName: "profile" */ '../../components/MyProfileEdit')
// const Units = () => import('../../components/Units')
const Skills = () => import(/* webpackChunkName: "admin" */ '../../components/Skills')
const BookingManagment = () => import(/* webpackChunkName: "booking" */ '../../components/BookingManagment')
const BookingView = () => import(/* webpackChunkName: "booking" */ '../../components/BookingView')
const InfoHr = () => import(/* webpackChunkName: "users" */ '../../components/UsersInfo/InfoHr')
const InfoPm = () => import(/* webpackChunkName: "users" */ '../../components/UsersInfo/InfoPm')
const Permission = () => import(/* webpackChunkName: "admin" */ '../../components/Permission')
const NotEstimated = () => import(/* webpackChunkName: "reports" */ '../../components/NotEstimated')
const FinancesClients = () => import(/* webpackChunkName: "finances" */ '@pages/FinancesClients')
const FinancesTaxTypes = () => import(/* webpackChunkName: "finances" */ '@pages/FinancesTaxTypes')
const FinancesExpensesCategories = () =>
  import(/* webpackChunkName: "finances" */ '../../components/FinancesExpensesCategories')
const FinancesExpenses = () => import(/* webpackChunkName: "finances" */ '../../components/FinancesExpenses')
const FinancesCompensations = () =>
  import(/* webpackChunkName: "finances" */ '../../components/FinancesCompensations')
const FinancesPayouts = () => import(/* webpackChunkName: "finances" */ '@pages/FinancePayoutsPage')
const FinancesPayoutsEdit = () => import(/* webpackChunkName: "finances" */ '@pages/FinancePayoutsEdit')
const FinancesPartners = () => import(/* webpackChunkName: "finances" */ '@pages/FinancePartnersPage')
const FinancesProjectSpecialisation = () =>
  import(/* webpackChunkName: "finances" */ '@pages/FinancesProjectSpecialisation')
const FinanceClientsBankDetails = () =>
  import(/* webpackChunkName: "finances" */ '@pages/FinanceClientsBankDetails')
const FinanceBankDetails = () => import(/* webpackChunkName: "finances" */ '@pages/FinanceBankDetails')
const FinanceBankDetailsCards = () => import(/* webpackChunkName: "finances" */ '@pages/FinanceBankDetailsCards')
const FinanceBankDetailsContractors = () =>
  import(/* webpackChunkName: "finances" */ '@pages/FinanceBankDetailsContractors')
const FinanceBankDetailsPartners = () =>
  import(/* webpackChunkName: "finances" */ '@pages/FinanceBankDetailsPartners')
const FinanceInvoices = () => import(/* webpackChunkName: "finances" */ '@pages/FinanceInvoices')
const FinanceInvoiceEdit = () =>
  import(/* webpackChunkName: "finances-invoices" */ '@pages/FinanceInvoiceEdit')
const FinanceReports = () => import(/* webpackChunkName: "finance-reports" */ '@pages/FinanceReports')
const FinanceReportsExpenses = () => import(/* webpackChunkName: "finance-reports" */ '@pages/FinanceReportsExpenses')
// const FinanceReportsBalances = () => import('@pages/FinanceReportsBalances')
const FinanceReportsProfitAndLoss = () =>
  import(/* webpackChunkName: "finance-reports" */ '@pages/FinanceReportsProfitAndLoss')
const FinanceReportsProfitAndLossHistorical = () =>
  import(/* webpackChunkName: "finance-reports" */ '@pages/FinanceReportsProfitAndLossHistorical')
// const FinanceReportsProfitAndLossCalculator = () =>
//   import('@pages/FinanceReportsProfitAndLossCalculator')
const NotBudget = () => import(/* webpackChunkName: "reports" */ '@pages/NotBudget')
const FinanceReportsPeopleAndProjects = () =>
  import(/* webpackChunkName: "finance-reports" */ '@pages/FinanceReportsPeopleAndProjects')
const FinanceSalesReportPage = () => import(/* webpackChunkName: "finance-reports" */ '@pages/FinanceSalesReportPage')
const FinanceSalesReportHistoricalPage = () =>
  import(/* webpackChunkName: "finance-reports" */ '@pages/FinanceSalesReportHistoricalPage')
const FinanceSalesChannelsPage = () =>
  import(/* webpackChunkName: "finance-reports" */ '@pages/FinanceSalesChannelsPage')
const MiscBacklog = () => import(/* webpackChunkName: "reports" */ '@pages/MiscBacklog')
const SystemOperations = () => import(/* webpackChunkName: "admin" */ '@pages/SystemOperationsPage')
const FinanceHPReportDetailedPage = () =>
  import(/* webpackChunkName: "finance-reports" */ '@pages/FinanceHPReportDetailedPage')
const FinanceHPReportOverviewPage = () =>
  import(/* webpackChunkName: "finance-reports" */ '@pages/FinanceHPReportOverviewPage')
const HoursTrackingReport = () => import(/* webpackChunkName: "reports" */ '@pages/HoursTrackingPage')
const HolidaysPage = () => import(/* webpackChunkName: "admin" */ '@pages/HolidaysPage')
const ProfilesWidget = () => import(/* webpackChunkName: "profile" */ '@pages/ProfilesWidgetPage')
const TimeOffsSettingsPage = () => import(/* webpackChunkName: "admin" */ '@pages/TimeOffsSettingsPage')
const TelegramPartners = () => import(/* webpackChunkName: "notifications" */ '@pages/notifications/TelegramPartners')
const TelegramContractors = () =>
  import(/* webpackChunkName: "notifications" */ '@pages/notifications/TelegramContractors')
const TelegramCampaignForPartners = () =>
  import(/* webpackChunkName: "notifications" */ '@pages/notifications/TelegramCampaignForPartners.vue')
const TelegramCampaignForContractors = () =>
  import(/* webpackChunkName: "notifications" */ '@pages/notifications/TelegramCampaignForContractors.vue')
const NewUserProfile = () =>
  import(/* webpackChunkName: "profile" */ '@pages/NewUserProfile.vue')
const TimeOffReport = () =>
  import(/* webpackChunkName: "reports" */ '@pages/TimeOffReport.vue')
const TimeOffReportById = () =>
  import(/* webpackChunkName: "reports" */ '@pages/TimeOffReportById.vue')
const TimeOffReportOverview = () =>
  import(/* webpackChunkName: "reports" */ '@pages/TimeOffReportOverview.vue')

function $routerCan (permission) {
  const Permission = store.getters.getPermission
  return Permission.indexOf(permission) !== -1
}

function forwardNext (hasPermissions, next) {
  if (hasPermissions) {
    next()
  } else {
    if ($routerCan('read_all-home')) {
      next({ name: ROUTES.HOME.name })
    } else {
      next({ name: 'my-profile' })
    }
  }
}

export default [
  {
    path: ROUTES.HOME.path,
    component: DefaultLayout,
    children: [
      {
        path: ROUTES.HOME.path,
        name: ROUTES.HOME.name,
        component: Home,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllHome), next),
        meta: {
          breadcrumb: { label: 'Home' }
        }
      },

      // Sign-in/Sign-up routes
      {
        path: ROUTES.SIGN_IN.path,
        name: ROUTES.SIGN_IN.name,
        component: SignIn
      },
      {
        path: ROUTES.SIGN_UP.path,
        name: ROUTES.SIGN_UP.name,
        component: SignUp
      },
      {
        path: ROUTES.CONFIRM_EMAIL.path,
        name: ROUTES.CONFIRM_EMAIL.name,
        component: ConfirmEmail
      },
      {
        path: ROUTES.COMPLETE_SIGN_UP.path,
        name: ROUTES.COMPLETE_SIGN_UP.name,
        component: CompleteSignUp
      },
      {
        path: ROUTES.ADD_AGENCY.path,
        name: ROUTES.ADD_AGENCY.name,
        component: AddAgency
      },
      {
        path: ROUTES.ADD_AGENCY_ATLASSIAN.path,
        name: ROUTES.ADD_AGENCY_ATLASSIAN.name,
        component: AddAgencyAtlassian
      },
      {
        path: ROUTES.INVITE_TEAMMATES.path,
        name: ROUTES.INVITE_TEAMMATES.name,
        component: InviteTeammates
      },
      {
        path: ROUTES.INVITE_TEAMMATES_ATLASSIAN.path,
        name: ROUTES.INVITE_TEAMMATES_ATLASSIAN.name,
        component: InviteTeammatesAtlassian
      },
      {
        path: ROUTES.WELCOME.path,
        name: ROUTES.WELCOME.name,
        component: Welcome
      },
      {
        path: ROUTES.PASSWORD_RESET.path,
        name: ROUTES.PASSWORD_RESET.name,
        component: PasswordReset
      },
      {
        path: ROUTES.PASSWORD_UPDATE.path,
        name: ROUTES.PASSWORD_UPDATE.name,
        component: PasswordUpdate
      },
      {
        path: ROUTES.CONFIRMATION_LINK_EXPIRED.path,
        name: ROUTES.CONFIRMATION_LINK_EXPIRED.name,
        component: ConfirmationLinkExpired
      },
      {
        path: ROUTES.INVITATION_LINK_EXPIRED.path,
        name: ROUTES.INVITATION_LINK_EXPIRED.name,
        component: InvitationLinkExpired
      },

      {
        path: '/working-time',
        name: 'working-time',
        component: LogTimeReport,
        meta: {
          breadcrumb: {
            label: 'Working Time',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadOwnLogTimeReports), next)
      },
      {
        path: '/time-off-report-overview',
        name: 'time-off-report-overview',
        component: TimeOffReportOverview,
        meta: {
          breadcrumb: {
            label: 'Time off report overview',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadOwnLogTimeReports), next)
      },
      {
        path: '/time-off-report',
        name: 'time-off-report',
        component: TimeOffReport,
        meta: {
          breadcrumb: {
            label: 'Time off report - detailed',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadOwnLogTimeReports), next)
      },
      {
        path: '/time-off-report/:id',
        name: 'time-off-report-id',
        component: TimeOffReportById,
        meta: {
          breadcrumb: {
            parent: 'time-off-report',
            label: 'Time off report - detailed'
          }
        },
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadOwnLogTimeReports), next)
      },
      {
        path: '/projects',
        name: 'projects',
        component: Projects,
        meta: {
          breadcrumb: {
            label: 'Projects',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_own-projects'), next)
      },
      {
        path: '/working-time-hours-tracking',
        name: 'working-time-hours-tracking',
        component: HoursTrackingReport,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadOwnLogTimeReports), next),
        meta: {
          breadcrumb: {
            label: 'Working Time Management',
            parent: 'home'
          }
        }
      },
      {
        path: '/time-offs-settings',
        name: 'time-offs-settings',
        component: TimeOffsSettingsPage,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-time_offs_settings'), next),
        meta: {
          breadcrumb: {
            label: 'Time offs settings',
            parent: 'home'
          }
        }
      },
      {
        path: '/backlog-time-report',
        name: 'backlog-time-report',
        component: BacklogTimeReport,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_own-backlog_reports'), next),
        meta: {
          breadcrumb: {
            label: 'Backlog Time Report',
            parent: 'home'
          }
        }
      },
      // hide because of GB2-2971
      // {
      //   path: '/unit-management',
      //   name: 'unit-management',
      //   component: UnitManagement,
      //   beforeEnter: (to, from, next) => forwardNext($routerCan('read_own-unit_management'), next),
      //   meta: {
      //     breadcrumb: {
      //       label: 'Unit Management',
      //       parent: 'home'
      //     }
      //   }
      // },
      {
        path: '/kpi-report',
        name: 'kpi-report',
        component: KpiReport,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_own-kpi_reports'), next),
        meta: {
          breadcrumb: {
            label: 'Kpi Report',
            parent: 'home'
          }
        }
      },
      {
        path: '/profile/:id/:type',
        name: 'profile',
        component: Profile,
        meta: {
          breadcrumb: {
            label: 'Profile',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-users'), next)
      },
      {
        path: '/profile/:id/:type/edit',
        name: 'profile-edit',
        component: ProfileEdit,
        meta: {
          breadcrumb: {
            label: 'Profile Edit',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => forwardNext($routerCan('update_all-users'), next)
      },
      {
        path: '/my-profile',
        name: 'my-profile',
        component: MyProfile,
        meta: {
          breadcrumb: {
            label: 'My Profile',
            parent: 'home'
          }
        }
      },
      {
        path: '/my-profile/edit',
        name: 'my-profile-edit',
        component: MyProfileEdit,
        meta: {
          breadcrumb: {
            parent: 'my-profile'
          }
        }
      },
      // hide because of GB2-2971
      // {
      //   path: '/units',
      //   name: 'units',
      //   component: Units,
      //   beforeEnter: (to, from, next) => forwardNext($routerCan('read_own-units'), next),
      //   meta: {
      //     breadcrumb: {
      //       label: 'Units',
      //       parent: 'home'
      //     }
      //   }
      // },
      {
        path: '/skills',
        name: 'skills',
        component: Skills,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-skills'), next),
        meta: {
          breadcrumb: {
            label: 'Skills',
            parent: 'home'
          }
        }
      },
      {
        path: '/booking-managment',
        name: 'booking-managment',
        component: BookingManagment,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_own-booking_management'), next),
        meta: {
          breadcrumb: {
            label: 'Booking Managment',
            parent: 'home'
          }
        }
      },
      {
        path: '/booking-view',
        name: 'booking-view',
        component: BookingView,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_own-booking_view'), next),
        meta: {
          breadcrumb: {
            label: 'Work schedule',
            parent: 'home'
          }
        }
      },
      {
        path: '/users',
        name: 'users',
        component: Users,
        meta: {
          breadcrumb: {
            label: 'Users',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-users'), next)
      },
      {
        path: '/users/info-hr',
        name: 'users-info-hr',
        meta: {
          breadcrumb: {
            label: 'Users info HR',
            parent: 'home'
          }
        },
        component: InfoHr,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_own-info_from_hr'), next)
      },
      {
        path: '/users/info-pm',
        name: 'users-info-pm',
        meta: {
          breadcrumb: {
            label: 'Users info PM',
            parent: 'home'
          }
        },
        component: InfoPm,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_own-info_from_pm'), next)
      },
      {
        path: '/permission',
        name: 'permission',
        meta: {
          breadcrumb: {
            label: 'Permissions',
            parent: 'home'
          }
        },
        component: Permission,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-permission'), next)
      },
      {
        path: '/system-operations',
        name: 'system-operations',
        meta: {
          breadcrumb: {
            label: 'System Operations',
            parent: 'home'
          }
        },
        component: SystemOperations,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-system_operations'), next)
      },
      {
        path: '/not-estimated',
        name: 'not-estimated',
        component: NotEstimated,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-not_estimated'), next),
        meta: {
          breadcrumb: {
            label: 'Not Estimated',
            parent: 'home'
          }
        }
      },
      {
        path: '/not-budget',
        name: 'not-budget',
        component: NotBudget,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-not_estimated'), next),
        meta: {
          breadcrumb: {
            label: 'Not Budget',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-clients',
        name: 'finances-clients',
        component: FinancesClients,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-finances_clients'), next),
        meta: {
          breadcrumb: {
            label: 'Finances Clients',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-partners',
        name: 'finances-partners',
        component: FinancesPartners,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-finances_partners'), next),
        meta: {
          breadcrumb: {
            label: 'Finances Clients',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-tax-types',
        name: 'finances-tax-types',
        component: FinancesTaxTypes,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-finances_tax_types'), next),
        meta: {
          breadcrumb: {
            label: 'Finances Tax types',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-expenses-categories',
        name: 'finances-expenses-categories',
        component: FinancesExpensesCategories,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-finances_expenses_category'), next),
        meta: {
          breadcrumb: {
            label: 'Finances Expenses Categories',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-expenses',
        name: 'finances-expenses',
        component: FinancesExpenses,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_own-finances_expenses'), next),
        meta: {
          breadcrumb: {
            label: 'Finances Expenses',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-compensations',
        name: 'finances-compensations',
        component: FinancesCompensations,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-finances_compensations'), next),
        meta: {
          breadcrumb: {
            label: 'Finances Compensations',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-payouts',
        name: 'finances-payouts',
        component: FinancesPayouts,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-finances_payouts'), next),
        meta: {
          breadcrumb: {
            label: 'Payouts',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-payouts/:id/edit',
        name: 'finances-payouts-edit',
        component: FinancesPayoutsEdit,
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-finances_payouts'), next),
        meta: {
          breadcrumb: {
            label: 'Payouts',
            parent: 'finances-payouts'
          }
        }
      },
      {
        path: '/finances-invoices-project-specialisations',
        name: 'finances-invoices-project-specialisations',
        component: FinancesProjectSpecialisation,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesProjectSpecialisations), next),
        meta: {
          breadcrumb: {
            label: 'Finances Project Specialisations',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-bank-details-clients',
        name: 'finances-bank-details-clients',
        component: FinanceClientsBankDetails,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesClientBankDetails), next),
        meta: {
          breadcrumb: {
            label: 'Finances Bank Details Clients',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-bank-details',
        name: 'finances-bank-details',
        component: FinanceBankDetails,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesOwnBankDetails), next),
        meta: {
          breadcrumb: {
            label: 'Finances Bank Details',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-bank-details-cards',
        name: 'finances-bank-details-cards',
        component: FinanceBankDetailsCards,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesOwnBankDetails), next),
        meta: {
          breadcrumb: {
            label: 'Finances Bank Details Cards',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-bank-details-contractors',
        name: 'finances-bank-details-contractors',
        component: FinanceBankDetailsContractors,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesContractorBankDetails), next),
        meta: {
          breadcrumb: {
            label: 'Finances Bank Details Contractors',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-bank-details-partners',
        name: 'finances-bank-details-partners',
        component: FinanceBankDetailsPartners,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesPartnerBankDetails), next),
        meta: {
          breadcrumb: {
            label: 'Finances Bank Details Partners',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-invoices',
        name: 'finances-invoices',
        component: FinanceInvoices,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesOwnBankDetails), next),
        meta: {
          breadcrumb: {
            label: 'Invoices',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-invoices/:id/edit',
        name: 'finances-invoices-edit',
        component: FinanceInvoiceEdit,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesOwnBankDetails), next),
        meta: {
          breadcrumb: {
            label: 'Invoices',
            parent: 'finances-invoices'
          }
        }
      },
      {
        path: '/finances-sales-report',
        name: 'finances-sales-report',
        component: FinanceSalesReportPage,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesPPReportProfitability), next),
        meta: {
          breadcrumb: {
            label: 'Finances Sales Report',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-sales-report-historical',
        name: 'finances-sales-report-historical',
        component: FinanceSalesReportHistoricalPage,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesPPReportProfitability), next),
        meta: {
          breadcrumb: {
            label: 'Finances Sales Report historical',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-invoices',
        name: 'finances-reports-invoices',
        component: FinanceReports,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesInvoices), next),
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Invoices',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-expenses',
        name: 'finances-reports-expenses',
        component: FinanceReportsExpenses,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesExpenses), next),
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Expenses',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-profit-and-loss',
        name: 'finances-reports-profit-and-loss',
        component: FinanceReportsProfitAndLoss,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesReportProfitAndLoss), next),
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Profit And Loss',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-profit-and-loss-historical',
        name: 'finances-reports-profit-and-loss-historical',
        component: FinanceReportsProfitAndLossHistorical,
        beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesReportProfitAndLoss), next),
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Profit And Loss Historical',
            parent: 'home'
          }
        }
      },
      // hide because of GB2-2971
      // {
      //   path: '/finances-reports-profit-and-loss-calculator',
      //   name: 'finances-reports-profit-and-loss-calculator',
      //   component: FinanceReportsProfitAndLossCalculator,
      //   beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesReportProfitAndLoss), next),
      //   meta: {
      //     breadcrumb: {
      //       label: 'Finances Reports - Profit And Loss Calculator',
      //       parent: 'home'
      //     }
      //   }
      // },
      {
        path: '/finances-reports-by-people-and-projects',
        name: 'finances-reports-by-people-and-projects',
        component: FinanceReportsPeopleAndProjects,
        beforeEnter: (to, from, next) => forwardNext(
          $routerCan(permissions.ReadAllFinancesPPReportMoney) ||
          $routerCan(permissions.ReadAllFinancesPPReportProfitability),
          next
        ),
        meta: {
          breadcrumb: {
            label: 'Finances Reports - By People And Projects',
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-hours-and-payments',
        name: 'finances-reports-hours-and-payments',
        component: FinanceHPReportDetailedPage,
        beforeEnter: (to, from, next) => forwardNext(
          $routerCan(permissions.ReadAllFinancesPPReportMoney) ||
          $routerCan(permissions.ReadAllFinancesPPReportProfitability),
          next
        ),
        meta: {
          breadcrumb: {
            parent: 'home',
            label: 'Finances reports hours and payments'
          }
        }
      },
      {
        path: '/finances-reports-hours-and-payments-overview',
        name: 'finances-reports-hours-and-payments-overview',
        component: FinanceHPReportOverviewPage,
        beforeEnter: (to, from, next) => forwardNext(
          $routerCan(permissions.ReadAllFinancesPPReportMoney) ||
          $routerCan(permissions.ReadAllFinancesPPReportProfitability),
          next
        ),
        meta: {
          breadcrumb: {
            parent: 'home'
          }
        }
      },
      {
        path: '/finances-reports-hours-and-payments/:id',
        name: 'h-p-report',
        component: FinanceHPReportDetailedPage,
        beforeEnter: (to, from, next) => forwardNext(
          $routerCan(permissions.ReadAllFinancesPPReportMoney) ||
          $routerCan(permissions.ReadAllFinancesPPReportProfitability),
          next
        ),
        meta: {
          breadcrumb: {
            parent: 'finances-reports-hours-and-payments',
            label: 'finances report'
          }
        }
      },
      // hide because of GB2-2971
      // {
      //   path: '/finances-reports-balances',
      //   name: 'finances-reports-balances',
      //   component: FinanceReportsBalances,
      //   beforeEnter: (to, from, next) => forwardNext($routerCan(permissions.ReadAllFinancesReportBalances), next),
      //   meta: {
      //     breadcrumb: {
      //       label: 'Finances Reports - Balances',
      //       parent: 'home'
      //     }
      //   }
      // },
      {
        path: '/finances-sales-channels',
        name: 'finances-sales-channels',
        component: FinanceSalesChannelsPage,
        beforeEnter: (to, from, next) => forwardNext(
          $routerCan(permissions.ReadAllFinancesPPReportMoney) ||
          $routerCan(permissions.ReadAllFinancesPPReportProfitability),
          next
        ),
        meta: {
          breadcrumb: {
            label: 'Finances Reports - Balances',
            parent: 'home'
          }
        }
      },
      {
        path: '/backlog-not-done-and-estimated',
        name: 'backlog-not-done-and-estimated',
        component: MiscBacklog,
        meta: {
          breadcrumb: {
            label: 'Backlog',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_own-backlog_reports'), next)
      },
      {
        path: '/holidays',
        name: 'holidays',
        component: HolidaysPage,
        meta: {
          breadcrumb: {
            label: 'Holidays',
            parent: 'home'
          }
        },
        beforeEnter: (to, from, next) => forwardNext($routerCan('read_all-holidays'), next)
      },
      {
        name: ROUTES.AVAILABLE_PROFILES.name,
        path: ROUTES.AVAILABLE_PROFILES.path,
        component: ProfilesWidget
      },
      {
        path: '/notifications/telegram/partners',
        name: 'notifications-telegram-partners',
        component: TelegramPartners
      },
      {
        path: '/notifications/telegram/contractors',
        name: 'notifications-telegram-contractors',
        component: TelegramContractors
      },
      {
        path: '/notifications/telegram/campaigns-for-partners',
        name: 'notifications-telegram-campaigns-for-partners',
        component: TelegramCampaignForPartners
      },
      {
        path: '/notifications/telegram/campaigns-for-contractors',
        name: 'notifications-telegram-campaigns-for-contractors',
        component: TelegramCampaignForContractors
      },
      {
        path: '/profile/new',
        name: 'new-user-profile',
        component: NewUserProfile
      }
    ]
  },
  {
    path: ROUTES.WILDCARD.path,
    name: ROUTES.WILDCARD.name,
    component: NotFound404
  }
]
